import type { UiStrings } from '@/constants/ui-locale'
import type { SharedRoomMember } from '@/pages/Meetings/utils/sharedRoomPresentation'
import LiveInviteButton from './LiveInviteButton'
import SharedRoomMembersPopover, {
  type WaitingInviteMember,
} from './SharedRoomMembersPopover'

export default function SharedRoomInRoomControls({
  members,
  waitingMembers = [],
  canLeave,
  canInvite,
  leaving,
  t,
  locale,
  onLeave,
  onInvite,
  onMembersOpen,
}: {
  members: SharedRoomMember[]
  waitingMembers?: WaitingInviteMember[]
  canLeave: boolean
  canInvite?: boolean
  leaving: boolean
  t: UiStrings
  locale: string
  onLeave: () => void
  onInvite?: () => void
  onMembersOpen?: () => void
}) {
  return (
    <div
      data-testid="shared-room-in-room-toolbar"
      className="flex shrink-0 flex-wrap items-center gap-1.5 sm:gap-2"
    >
      {members.length > 0 || waitingMembers.length > 0 ? (
        <SharedRoomMembersPopover
          members={members}
          waitingMembers={waitingMembers}
          t={t}
          locale={locale}
          onOpen={onMembersOpen}
        />
      ) : null}
      {canInvite && onInvite ? <LiveInviteButton t={t} onClick={onInvite} /> : null}
      {canLeave ? (
        <button
          type="button"
          disabled={leaving}
          onClick={onLeave}
          className="shrink-0 rounded-lg border border-red-200 px-2 py-0.5 text-[11px] font-semibold text-red-700 transition-colors hover:bg-red-50 disabled:opacity-50 dark:border-red-900/50 dark:text-red-300 dark:hover:bg-red-950/30 sm:text-xs"
        >
          {t.sharedRoomLeave}
        </button>
      ) : null}
    </div>
  )
}
